<template>
  <div id="app" class="v2layout">
    <!-- v2官网 -->
    <div class="v2container client">
      <clientb-header></clientb-header>
      <div class="clientBMain">
        <transition name="slide-left">
          <keep-alive include="Document">
            <router-view :key="key"></router-view>
          </keep-alive>
        </transition>
      </div>
      <clientb-footer></clientb-footer>
      <!-- 快捷入口 -->
      <fast-entry></fast-entry>
    </div>
  </div>
</template>
<script>
  // 避免组件的名称和html 原生相同
  // 路径参考alias
  import { mapActions, mapMutations, mapState } from 'vuex';
  import _ from 'lodash'; 
  import Cookies from 'js-cookie';
  import ClientbHeader from 'views/common/Header.vue';
  import ClientbFooter from 'views/common/Footer.vue';
  import FastEntry from 'views/common/FastEntry.vue';
  export default {
    data(){
      return {
        isRouterAlive:true,
        key: 0
      }
    },
    components: {
      ClientbHeader,
      ClientbFooter,
      FastEntry
    },
    computed: {
      ...mapState({
        profile: state=>state.User.profile,
      }),
    },
    mounted(){
      this.getInfo();
    },
    //监听路由改变
    watch: {
      '$route'(to, from){
        // 首页进入常见问题清楚缓存
        if(from.name ==='Home' && to.name === 'CommonQuestion'){
          this.key+=1;
        }
      }
    },
    methods:{
      ...mapActions(['userInfo']),
      ...mapMutations(['setProfile']),
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
      },
      // 登录并获取个人信息
      getInfo(){
        const key = feConfig.api.clientCk;
        const token = Cookies.get(key);
        if (token && _.isEmpty(this.profile)) {
          this.userInfo();
        }else{
          this.setProfile({ userName:'', isMember: 0 });
        }
      }
    }
  };
</script>
<style lang="sass" rel="stylesheet/scss">
@import "../node_modules/element-ui/lib/theme-chalk/index.css";
@import "assets/styles/main";
.v2container {
  min-height: 100vh;
  position: relative;
  .adminMain {
    width: 1200px;
    margin: 20px auto;
    overflow: hidden;
    display: flex;
    height: calc(100% - 40px);
  }
  .clientBMain{
    width: 1200px;
    margin: 88px auto 0;
  }
}
.el-pagination{
  text-align: center;
  margin-top: 20px;
}

.slide-left-enter-from,
.slide-left-leave-to{
	opacity: 0;
}
 
.slide-left-enter-active {
	transition: all 1s;
}
.slide-left-leave-active {
	transition: all 0s;
}
</style>



// WEBPACK FOOTER //
// App.vue?7e56be7e